import React from "react";
import PropTypes from "prop-types";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";

/********************************
<Richtext />
/********************************
Version: 1
Created: 24 01 2025
Updated: 19 02 2025
Author: Richy Pears
/********************************
It's just a rich textbox, lads
/********************************/

const Richtext = ({ blok }) => {
  if (!blok) return null; // Escape hatch

  const { copy, padding, rounded, theme, text_align } = blok;

  const colour = SmartColour(theme);

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container">
        {copy && (
          <SmartText className={text_align && text_align}>{copy}</SmartText>
        )}
      </div>
    </section>
  );
};

export default Richtext;

Richtext.defaultProps = {
  blok: null,
};

Richtext.propTypes = {
  blok: PropTypes.object,
};
